import axios from "axios"
import { BASE_URL } from '../constants/urlConstants'
import { CERTIFICATE_LIST_FAIL,
         CERTIFICATE_LIST_REQUEST,
         CERTIFICATE_LIST_SUCCESS } from "../constants/certificateConstansts"

  
  export const fetchCertificate = () => async(dispatch) => {
    try{
        dispatch({type: CERTIFICATE_LIST_REQUEST})

        const { data } = await axios.get(`${BASE_URL}/certificate/`)
        dispatch({type: CERTIFICATE_LIST_SUCCESS , payload: data})

    }catch(error){
        dispatch({type: CERTIFICATE_LIST_FAIL,
            payload: error.response && error.response.data.message
                ? error.response.data.message
                : error.message
        })

    }

  }



  
  
  

  
  

  
  
  
  
  
  

  

  



